// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divImgLittle[data-v-27d3d2b1],.littleObjetivo[data-v-27d3d2b1]{height:55px;width:55px}.bigObjetivo[data-v-27d3d2b1],.q-img[data-v-27d3d2b1]:hover{height:70px;width:70px}.q-btn[data-v-27d3d2b1]{border:none!important}", ""]);
// Exports
module.exports = exports;
